import React from 'react'
import {Box} from '@mui/material'
import {Icon, ReadOnlyPipeSeprated} from '@/components/atoms'
import {copyToClipboard} from '@/shared/utils/commons'
import PropTypes from "prop-types"
import './_overViewSubHeader.scss'
/**
 * OverViewSubHeader component displays a header with an icon and a list of labeled items.
 *
 * @param {Object} props - The component props.
 * @param {string} props.id - The id for the Box component.
 * @param {Array} props.items - The array of items to display, each item should have a `label` and `value` property.
 *
 * @returns {JSX.Element} The rendered OverViewSubHeader component.
 */
const OverViewSubHeader = ({ id, items, isIconHidden = false }) => {
  return (
    <Box id={id} className={`flex items-center pb-4 pt-2`}>
      {!isIconHidden && <Icon className="ovsh-icon-color" icon={'verified_user'} size={'small'} />}
      {items?.map((obj, index) => (
        <div className={`flex items-center`} key={`${obj.label}`}>
          <ReadOnlyPipeSeprated
            isRightBorderVisible={items.length - 1 !== index}
            label={obj.label}
            value={obj.value}
            id={index}
            key={obj.label}
          />
          {obj?.copy && (
            <Icon
              className="copy-icon-color"
              icon={'content_copy'}
              size={'small'}
              key={obj.label}
              onClick={() => copyToClipboard(obj.value)}
            />
          )}
        </div>
      ))}
    </Box>
  );
};

OverViewSubHeader.propTypes = {
  id: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      copy: PropTypes.bool
    })
  ),
  isIconHidden: PropTypes.bool
};

export default OverViewSubHeader;
